/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useEffect, useRef } from 'react';
import BackgroundYellow from './snurrtext2.png';
import Jazzkoket from './Jazzkoket.png';
import BounsingArrow from './arrow.png';
import BounsingArrow2 from './arrow2.png';


import './App.css';

function App() {
  const [isDropdown1Open, setIsDropdown1Open] = useState(false);
  const [isDropdown2Open, setIsDropdown2Open] = useState(false);

  const [isArrowVisible, setIsArrowVisible] = useState(false);


  const dropdown1Ref = useRef(null);
  const dropdown2Ref = useRef(null);
  const button1Ref = useRef(null);
  const button2Ref = useRef(null);

  const toggleDropdown1 = () => setIsDropdown1Open(!isDropdown1Open);
  const toggleDropdown2 = () => setIsDropdown2Open(!isDropdown2Open);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsArrowVisible(true); // Show the arrow after 1 second
    }, 1000); // Delay in milliseconds (1000ms = 1 second)
  
    // Clean up the timeout when the component unmounts
    return () => clearTimeout(timer);
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdown1Ref.current && 
        !dropdown1Ref.current.contains(event.target) && 
        button1Ref.current &&
        !button1Ref.current.contains(event.target)
      ) {
        setIsDropdown1Open(false);
      }
      if (
        dropdown2Ref.current && 
        !dropdown2Ref.current.contains(event.target) && 
        button2Ref.current &&
        !button2Ref.current.contains(event.target)
      ) {
        setIsDropdown2Open(false);
      }
    };

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="App">
      {/* Fixed background layer */}
      <div className="background"></div>

      <header className="App-header">
        <div className="logo-date-container">
          <img src={Jazzkoket} alt="Jazzkoket logo" className="jazzkoket-logo" />
          14/6
        </div>
        <p className="big-text">
          Spekt<br />
          aklet
        </p>
        <div className="vad-text-container">
          <img src={BackgroundYellow} alt="Spiral text" className="spiral" />
        </div>
<div className="arrow-container">
  {isArrowVisible && <img src={BounsingArrow} alt="Bouncing arrow" className="arrow" />}
</div>
        <div className="button-container">
          <button
            ref={button2Ref}
            className={`blob-button ${isDropdown2Open ? 'blob-button-open' : ''}`}
            onClick={toggleDropdown2}
          >
            Berätta mer! ツ
          </button>

          {isDropdown2Open && (
            <div className="dropdown-content" ref={dropdown2Ref}>
              <div className="event-info">
                <p>
                Som ni förstår har vi flera anledningar till att fira och vi vill fira med er, därav detta spektakel! Festen kommer bland annat att innehålla livemusik, mat & dryck från Jämtlands bästa kök och kareokebar.... <br /><br />╰( ͡° ͜ʖ ͡° )つ──☆* - *mic drop*.
                </p>
                <h3>Detaljer</h3>
                <strong>Plats:</strong><br /> Jazzköket, Prästgatan 44, Östersund.
                <br /><br />
                <strong>Datum / Tid:</strong><br /> Lördag 14/6 2025. Kl 16 - sent.
                <br /><br />
                <strong>Klädkod:</strong><br /> Det du känner dig fin i. Det gör ingenting om du sticker ut!
                <br /><br />
                <strong>Presenter:</strong><br /> Vi önskar oss inget mer än att ni kommer på denna fest!
                <br /><br />
                <strong>Kuvertavgift:</strong><br /> 500kr/gäst swishas, gärna i samband med anmälan, till 070-3070490. Dealine för kuvertavgift 1/5 2025. Kom ihåg att ange ditt/era namn i meddelandet.
                <br /><br />
                <strong>Värdinna:</strong><br /> Har ni frågor eller funderingar så kan ni alltid kontakta oss direkt, alternativt via vår eminenta värdinna: Anna Henriksson. Anna nås bäst via mail på <a href="mailto:spektakletmailen@gmail.com?subject=Till%20Spektaklet-Anna!">spektakletmailen@gmail.com</a> eller telefonnummer 070-2935576.
                <br /><br />
                <strong>Framträdanden:</strong> <br />På Jazzkökets scen kommer det att finnas ett husband med en repertoar för kvällen. Känner du att du skulle vilja bidra till denna, maila gärna Andreas <a href="mailto:spektakletmailen@gmail.com?subject=Till%20Spektaklet-Andreas!">spektakletmailen@gmail.com</a> så får du veta mer. 
                  Personliga tal tackar vi vänligt men bestämt nej till pga logistiska skäl. 
                <br /><br />
                <strong>Boende:</strong><br />Det finns många hotell och vandrarhem i närheten, då Jazzköket ligger mitt i stan. Vi rekomenderar Clarion Hotel Grand (5 min promenad från festlokalen), här får ni 15% rabatt om ni bokar via mail till <a href="mailto:cl.ostersund@strawberry.se">cl.ostersund@strawberry.se</a> och uppger koden <em>“Spektaklet”</em>. 
                Vi kommer själva att bo här, så då kan vi käka frulle ihop!
                <br /><br />
                <a href="https://visitostersund.se/hotell-och-pensionat-i-ostersund/" target="_blank" rel="noopener noreferrer">
                  Se fler boendealternativ här
                </a>
                <br /><br />
                  <strong>Anmälan:</strong> <br />Görs via formuläret nedan. Vi ser verkligen fram emot att träffa er! ♡
                  <div className="arrow-container2">
  {isArrowVisible && <img src={BounsingArrow2} alt="Bouncing arrow" className="arrow-small" />}
</div>
              </div>
            </div>
          )}

          <button
            ref={button1Ref}
            className={`blob-button ${isDropdown1Open ? 'blob-button-open' : ''}`}
            onClick={toggleDropdown1}
          >
            Låt oss fira! ⌐■_■
          </button>
          {isDropdown1Open && (
            <div className="dropdown-content2" ref={dropdown1Ref}>
              <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLScChRX1yX4eadlVJvDGw4HZwTBhb69XVdbwrlAvZ70mFnMYNQ/viewform?embedded=true"
                width="100%"
                height="650"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
              >
                Loading…
              </iframe>
            </div>
          )}
        </div>
      </header>
    </div>
  );
}

export default App;
